module.exports = __webpack_public_path__ + "img/add-to-apple-wallet-logo.png";